if (document?.querySelector('#dialog-openButton')) {
    function collectionDialogTrigger() {
        const showButton = document?.querySelector('#dialog-openButton')
        const closeButton = document?.querySelector('#dialog-closeButton')
        const dialog = document?.querySelector('.cus-modal-wrapper')
    
        showButton.addEventListener('click', () => {
            dialog.showModal()
        })
    
        closeButton.addEventListener('click', () => {
            dialog.close()
        })
    }
    
    collectionDialogTrigger()
}
